// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__5a-61","row":"ProcedureTreatmentSummary_row__1Ru54"};